/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Failed_TitleInputs */

const en_auth_failed_title = /** @type {(inputs: Auth_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication failed`)
};

const pt_br2_auth_failed_title = /** @type {(inputs: Auth_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na autenticação`)
};

/**
* | output |
* | --- |
* | "Authentication failed" |
*
* @param {Auth_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const auth_failed_title = /** @type {((inputs?: Auth_Failed_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Failed_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_failed_title(inputs)
	return pt_br2_auth_failed_title(inputs)
});